module.exports = __webpack_public_path__ + "img/SketchPngd6441087fd632a3a4d8106aae7c49968e327173ac9f141a55be53c2197571703.d763add9.png";